<template>
<div :class="bem()" :style="`padding:0px ${vm.width < 400? 40: 80}px`">
    <div :class="bem('title')">绑定手机更方便</div>


    <div :class="bem('item')">
        <PhoneNumber v-model="vm.form.phone" :countries="vm.countries" />
    </div>

    <div :class="bem('item')">
        <Input v-model="vm.form.verifyCode" maxlength="4" autocomplete="off" placeholder="输入短信中的验证码"/>
        <Button
            rect
            :class="bem('sms-btn')"
            nativeType="button"
            @click="sendVerifyCode"
            :disabled="!!codePendingRemain"
        >
            {{codePendingRemain ? `${codePendingRemain}秒后获取` : '获取验证码'}}
        </Button>
    </div>
    <Button
        type="primary"
        size="large"
        :class="bem('submit')"
        @click="onRegister"
        nativeType="submit"
        :disabled="loading">
        {{ loading ? '绑定中...' : '绑定手机号'}}
    </Button>
    <div :class="bem('desc')">
        绑定后即可用该手机号登录所有稿定产品，包括APP、小程序、H5等
    </div>
    <div :class="bem('footer')">
        <span>您可用此手机号找回账号</span>
    </div>
</div>

</template>
<script>
import _Message from "@gaoding/gdui/lib/message";
import _Input from "@gaoding/gdui/lib/input";
import _Button from "@gaoding/gdui/lib/button";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import PhoneNumber from './phone-number/index.vue';
import bemMixin from './bem';
import guestUser from './guestUser';
export default {
  name: 'g-auth-third-login',
  components: {
    Button: _Button,
    PhoneNumber: PhoneNumber,
    Input: _Input
  },
  mixins: [bemMixin],
  inject: ['vm'],
  data: function data() {
    return {
      loading: false,
      codePendingRemain: null
    };
  },
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.codePendingTimer);
  },
  methods: {
    onRegister: function onRegister() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var guest_finger, XGuestToken;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.loading) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this.loading = true;
                guest_finger = guestUser.guestfinger;
                XGuestToken = guest_finger && guest_finger !== '' ? {
                  'X-Guest-Token': guest_finger
                } : {};

                _this.vm.requestUms('thirdLogin', _objectSpread(_objectSpread({}, _this.vm.form), {}, {
                  token: _this.vm.thirdToken,
                  type: 'lenovo'
                }), XGuestToken).then(function (res) {
                  _this.vm.onLogin('thirdLogin').then(function () {
                    _this.loading = false;

                    _this.vm.$emit('success', {
                      action: 'thirdLogin',
                      type: 'mobile',
                      phone: _this.vm.form.phone.number
                    });
                  }).catch(function () {
                    _this.loading = false;
                  });
                }).catch(function (error) {
                  _this.loading = false;

                  _this.vm.$emit('error', {
                    error: error,
                    action: 'thirdLogin',
                    type: 'mobile'
                  });
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    sendVerifyCode: function sendVerifyCode() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _this2.vm.requestUms('sendVerifyCode', _objectSpread(_objectSpread({}, _this2.vm.form), {}, {
                  type: 'bind'
                }));

              case 3:
                _this2.startCheckCodePending();

                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2["catch"](0);

                _Message.error(_context2.t0);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 6]]);
      }))();
    },
    startCheckCodePending: function startCheckCodePending() {
      var _this3 = this;

      var check = function check() {
        _this3.codePendingRemain -= 1;

        if (_this3.codePendingRemain <= 0) {
          _this3.codePendingRemain = null;
          return;
        }

        _this3.codePendingTimer = setTimeout(check, 1000);
      };

      clearTimeout(this.codePendingTimer);
      this.codePendingTimer = setTimeout(check, 1000);
      this.codePendingRemain = 60;
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-third-login .g-auth-third-login__title {
  line-height: 31px;
  color: #000;
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 16px;
  text-align: center;
}
.g-auth-third-login .g-auth-third-login__desc {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #33383E;
  margin-top: 24px;
}
.g-auth-third-login .g-auth-third-login__item {
  display: flex;
}
.g-auth-third-login .g-auth-third-login__item + .g-auth-third-login__item {
  margin-top: 16px;
}
.g-auth-third-login .g-auth-third-login__sms-btn {
  width: 100px;
  height: 44px;
  background: #ececec;
  color: #424242;
  flex: 0 0 auto;
  font-weight: 400;
  border: none;
  padding: 0;
  font-size: 14px;
  margin-left: 12px;
}
.g-auth-third-login .g-auth-third-login__sms-btn:hover:hover {
  background: #ccc;
  color: #111;
}
.g-auth-third-login .g-auth-third-login__submit {
  margin-top: 24px;
  width: 100%;
  height: 44px;
  line-height: 44px;
}
.g-auth-third-login .g-auth-third-login__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding-left: 24px;
  height: 48px;
  width: 100%;
  color: #999;
  font-size: 14px;
  background: #F0F3F4;
  text-align: center;
  border-radius: 0 0 4px 4px;
}

</style>
